/* World Order — storefront JS */
(function () {
  'use strict';

  // ── Cart count refresh ──
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.parentElement && el.parentElement.toggleAttribute('data-has-items', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  // ── Mobile menu drawer ──
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    var closeTimer;

    function isOpen() { return document.body.classList.contains('menu-open'); }

    function open() {
      clearTimeout(closeTimer);
      menu.hidden = false;
      // Force a reflow so the opening transition runs from the hidden state.
      void menu.offsetWidth;
      document.body.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
    }

    function close() {
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      closeTimer = setTimeout(function () { menu.hidden = true; }, 240);
    }

    toggle.addEventListener('click', function () { isOpen() ? close() : open(); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 680 && isOpen()) close(); });
  }

  // ── PDP: gallery thumbs ──
  function initGallery(root) {
    var main = root.querySelector('[data-main-img]');
    if (!main) return;
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-thumb');
        var alt = btn.getAttribute('data-alt') || '';
        if (main.tagName === 'IMG') {
          // Clear srcset so the swapped src actually takes effect.
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
          main.alt = alt;
        }
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  // ── PDP: quantity stepper ──
  function initQty(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  }

  // ── PDP: variant selection ──
  function initVariants(form) {
    if (!form) return;
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var buyBtn = form.querySelector('[data-buy-btn]');
    var selected = {};

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var current = group.querySelector('[aria-pressed="true"]');
      if (current) selected[idx] = current.getAttribute('data-value');
      group.querySelectorAll('[data-value]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('[data-value]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true');
          selected[idx] = sw.getAttribute('data-value');
          update();
        });
      });
    });

    function update() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || selected[i] === opt; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (buyBtn) {
        if (match.available) { buyBtn.disabled = false; buyBtn.textContent = buyBtn.getAttribute('data-label-add'); }
        else { buyBtn.disabled = true; buyBtn.textContent = buyBtn.getAttribute('data-label-sold'); }
      }
    }
    update();
  }

  // ── Newsletter inline success ──
  function initNewsletter() {
    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      document.querySelectorAll('[data-newsletter-success]').forEach(function (el) { el.hidden = false; });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('.pdp-form').forEach(function (f) { initQty(f); initVariants(f); });
    initNewsletter();
    refreshCartCount();
  });
})();
